import { LocateStorePanelTitleSX } from '@/components/content/Header/styles/locateStore/parts/panelTitle';
import DynamicIcon from '@/components/icons/DynamicIcon';
import { useLocalization } from '@/data/Localization';
import { Box, IconButton, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import {
	MATERIAL_SYMBOL_ICONS,
	OpenSansFontWeights,
} from 'shared/custom/constants/commonConstants';

type Props = {
	handleClose: () => void;
};

export const LocateStorePanelTitle = ({ handleClose }: Props) => {
	const StoreLocator = useLocalization('StoreLocator');
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

	return (
		<Stack
			direction="row"
			justifyContent="space-between"
			sx={LocateStorePanelTitleSX.containerPadding}
		>
			<Box display="flex" alignItems="center">
				{isMobile ? (
					<DynamicIcon name={MATERIAL_SYMBOL_ICONS.store} sx={LocateStorePanelTitleSX.icon} />
				) : null}
				<Typography
					variant="body1"
					component={'span'}
					fontWeight={OpenSansFontWeights.semibold}
					sx={LocateStorePanelTitleSX.title}
				>
					{StoreLocator.panelAskLocationTittle.t()}
				</Typography>
			</Box>
			{isMobile ? (
				<IconButton
					onClick={handleClose}
					aria-label="close"
					className="store-selector__close"
					sx={LocateStorePanelTitleSX.cursorPointer}
				>
					<DynamicIcon name={MATERIAL_SYMBOL_ICONS.close} />
				</IconButton>
			) : null}
		</Stack>
	);
};
